import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faUser } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Login.css';
import { useNavigate, } from 'react-router';
import { login } from '../../../api';
import { Link as Anchor } from 'react-router-dom';
export default function Login() {
    const [accessCode, setAccessCode] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const handleLogin = async (e) => {
        e.preventDefault();

        try {
            // Migrado: login.php + cookie → login() del cliente api.js (guarda el Bearer token).
            const usuario = await login(accessCode, password);
            toast.success('Inicio de sesión exitoso como ' + usuario.rol);
            setTimeout(() => {
                window.location.reload();
            }, 1500);
        } catch (error) {
            const msg = error.message || 'Error al iniciar sesión';
            setErrorMessage(msg);
            toast.error(msg);
        }
    };

    return (
        <div className='formContain'>
            <ToastContainer />
            <Anchor to={`/`} >
                {/* <img src={logo} alt="" /> */}
                <FontAwesomeIcon icon={faUser} className='logoAtuh' />
            </Anchor>
            <h2>Administrador</h2>
            <form onSubmit={handleLogin} className='formAuth'>
                <div className='inputsAuth'>
                    <label htmlFor="access_code">No. Empleado/Estudiante</label>
                    <input
                        type="text"
                        id="access_code"
                        name="access_code"
                        value={accessCode}
                        onChange={(e) => setAccessCode(e.target.value)}
                        required
                        placeholder="No. Empleado/Estudiante"
                    />
                </div>
                <div className='inputsAuth'>
                    <label htmlFor="password">Contraseña:</label>
                    <div className='deFlexInputs'>
                        <input
                            type={showPassword ? 'text' : 'password'}
                            id="password"
                            name="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            placeholder="Contraseña"
                        />
                        <button
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                        </button>
                    </div>
                </div>

                <button type="submit" className='btn'>
                    Iniciar Sesión
                </button>
            </form>


        </div>
    );
}
